/**
 * The list of changes between two states of the drawings (describeChanges of @elec/export):
 * per sheet, what was added, changed (with the values) and removed. A sheet name opens it.
 */
import type { Id } from '@elec/domain';
import type { Translate } from '@elec/i18n';
import type { ChangeReport } from '@elec/export';
import { Dialog } from './ui.tsx';

export function ChangesDialog(props: {
  t: Translate;
  title: string;
  report: ChangeReport | null;
  onSheet(id: Id): void;
  onPdf(): void;
  onClose(): void;
}) {
  const { t, report } = props;
  const kind = { added: t('rev.kindAdded'), changed: t('rev.kindChanged'), removed: t('rev.kindRemoved') };
  return (
    <Dialog
      title={props.title}
      wide
      onClose={props.onClose}
      actions={
        <>
          <button onClick={props.onClose}>{t('dialog.close')}</button>
          <button className="primary" onClick={props.onPdf} data-testid="changes-pdf">
            {t('rev.pdf')}
          </button>
        </>
      }
    >
      {report && !report.sheets.length && <p className="muted">{t('rev.noChange')}</p>}
      <div data-testid="changes-list">
        {report?.sheets.map((s) => (
          <section key={s.sheetId} className="changes-sheet">
            <h4>
              <button className="link" onClick={() => props.onSheet(s.sheetId)}>
                {s.name}
              </button>
            </h4>
            <ul>
              {s.items.map((i, k) => (
                <li key={k} className={`change-${i.kind}`} data-kind={i.kind}>
                  <strong>{kind[i.kind]}</strong> · {[i.tag, i.name].filter(Boolean).join(' — ')}
                  {i.details.length > 0 && (
                    <ul>
                      {i.details.map((d, j) => (
                        <li key={j}>{d}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
              {s.wires.added + s.wires.removed + s.wires.changed > 0 && (
                <li className="muted">{t('rev.wires', s.wires)}</li>
              )}
            </ul>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
